import React, {useCallback} from 'react';
import {Button, Flex, Text, Title} from '@priority-software/priority-style-react';
import styles from '../styles.module.scss';
import EmailTemplateIcon from '../icons/EmailTemplate';
import {INewEmailTemplate} from '../NewEmailTemplate';
import {isRTL} from '../../../../../../../../../../Localization';
import {createDataTestId} from '../../../../../../../../../../utils/dataTestId';
import {texts} from '../../../../../../../../../EmailEditor/texts';

export const useNewEmailTemplate = ({handleEmailDialog, subject}: INewEmailTemplate) => {
    const renderIcon = useCallback(
        () => (
            <div>
                <EmailTemplateIcon height="200" width="220" />
            </div>
        ),
        []
    );

    const renderSubject = useCallback(
        () => (
            <Flex
                direction="column"
                alignItems="flex-start"
                componentClasses={styles.subjectContainer}
            >
                <Text textColor="secondary-500" skin="label-1">
                    {texts.email_subject_label}
                </Text>
                <Title
                    {...createDataTestId(`new-email-subject-text`, true)}
                    componentClasses={styles.subjectTemplate}
                    skin="h4"
                    text={subject || texts.email_subject_placeholder}
                />
            </Flex>
        ),
        [subject]
    );

    const renderButtons = useCallback(
        () => (
            <Button
                {...createDataTestId(`new-email-edit-button`, true)}
                onClick={handleEmailDialog}
                size={'small'}
                componentClasses={isRTL() ? styles.marginLeft : styles.marginRight}
            >
                {texts.email_edit_mail_button}
            </Button>
        ),
        []
    );

    return {renderIcon, renderSubject, renderButtons} as const;
};
